/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  TextField,
  SelectInput,
  Datagrid,
  BooleanField,
  Identifier,
  useTranslate,
  FunctionField,
  ReferenceField,
} from 'react-admin'
import { PRODUCT_REVIEWS_FIELDS } from '../../../providers/localization/constant'
import { ListBase } from '../../base'
import { DateField, RatingField } from '../../fields'
import { useParams } from 'react-router-dom'

export const ProductReviewDataList = (): JSX.Element => {
  const { id: productId } = useParams()
  const title = 'resources.product_reviews.name'
  const translate = useTranslate()
  const productReviewListFilter = [
    <SelectInput
      key={0}
      label={`${PRODUCT_REVIEWS_FIELDS}.is_active.label`}
      source='is_active'
      choices={[
        { id: 'true', name: `${PRODUCT_REVIEWS_FIELDS}.is_active.choices.active` },
        { id: 'false', name: `${PRODUCT_REVIEWS_FIELDS}.is_active.choices.inActive` },
      ]}
      alwaysOn
    />,
  ]

  const handleRowClick = (id: Identifier): string => {
    return `/products-reviews/${id}/show`
  }

  return (
    <>
      <ListBase
        title={translate(title)}
        resource='products-reviews'
        filter={{ product_id: productId }}
        listAction={{
          hasExport: false,
          hasCreate: false,
        }}
        // filters={productReviewListFilter}
        sort={{ field: 'create_at', order: 'desc' }}
      >
        <Datagrid
          rowClick={handleRowClick}
          bulkActionButtons={false}
          isRowSelectable={(): boolean => false}
        >
          <RatingField source='score' label={`${PRODUCT_REVIEWS_FIELDS}.score.label`} />
          <TextField source='subject' label={`${PRODUCT_REVIEWS_FIELDS}.subject.label`} />
          <FunctionField
            source='message'
            label={`${PRODUCT_REVIEWS_FIELDS}.message.label`}
            sortable={false}
            render={({ message }): string =>
              message.length > 200 ? `${message.slice(0, 200)}...` : message
            }
          />
          <TextField source='full_name' label={`${PRODUCT_REVIEWS_FIELDS}.full_name.label`} />
          {/* <ReferenceField
          source='product_id'
          reference='products'
          label={`${PRODUCT_REVIEWS_FIELDS}.product.label`}
          sortBy='prod_name_th'
        >
          <TextField source='prod_name_th' />
        </ReferenceField>
        <ReferenceField
          source='product_id'
          reference='products'
          label={`${PRODUCT_REVIEWS_FIELDS}.product_group.label`}
          sortBy='product_type'
        >
          <TextField source='product_group_title_th' />
        </ReferenceField> */}
          <DateField
            source='create_at'
            showTime
            label={`${PRODUCT_REVIEWS_FIELDS}.create_at.label`}
            textAlign='center'
          />
          <BooleanField
            source='is_active'
            label={`${PRODUCT_REVIEWS_FIELDS}.is_active.label`}
            textAlign='center'
          />
        </Datagrid>
      </ListBase>
    </>
  )
}
